import { utils } from '@febos-io/common';

export const getSettings = () => ({
  path: 'v1/users/me',
  config: {
    alias: 'setting.me',
  },
});

export const resetPassword = (email) => ({
  path: '/v1/users/password/reset',
  method: utils.METHOD.POST,
  content: {
    username: email,
  },
});

export const resetPasswordUpdate = (code, password, newPassword) => ({
  path: '/v1/users/password/reset',
  method: utils.METHOD.PUT,
  content: {
    code,
    password,
    newPassword,
  },
});

export const resetExternalPassword = (email) => ({
  path: 'v1/person/password/reset',
  method: utils.METHOD.POST,
  content: {
    username: email,
  },
});

export const getPersonSetting = () => ({
  path: 'v1/person/me',
});

export const getSystemLogList = (id = '') => ({
  path: '/v1/systems/activities/logs',
  params: {
    id: id.trim(),
  },
});

export const getRoleList = (page, limit, filter) => ({
  path: '/v1/systems/roles',
  params: {
    page,
    limit,
    content: filter,
  },
});

export const getPermisionsList = () => ({
  path: '/v1/systems/permissions',
});

export const getPermisionsByIdList = (id) => ({
  path: `/v1/systems/roles/${id}/permissions`,
});

export const saveNewRole = (name, description) => ({
  path: '/v1/systems/roles',
  method: utils.METHOD.POST,
  content: {
    name,
    description,
  },
});

export const editRole = (name, description, id) => ({
  path: `/v1/systems/roles/${id}`,
  method: utils.METHOD.PUT,
  content: {
    name,
    description,
  },
});

export const setPermisionsByIdList = (id, ids) => ({
  path: `/v1/systems/roles/${id}/permissions`,
  method: utils.METHOD.POST,
  content: {
    ids,
  },
});

export const vinculeExamToCase = (companyId, idExam, idCase, type) => ({
  path: `/v1/companies/${companyId}/documents/${type}/${idCase}/exams/vincule`,
  method: utils.METHOD.POST,
  content: {
    id: idExam,
  },
});

export const requestDesign = (companyId, idCase, type) => ({
  path: `/v1/companies/${companyId}/documents/${type}/${idCase}/request/design`,
  method: utils.METHOD.POST,
});
